import React from "react";
import { useQuery } from "react-query";

import { getCategoriesByLanguage } from "../common/api";
import { Link } from "react-router-dom";
import { getCategoryFullName } from "../common/functions";

import LoadingComponent from "../components/LoadingComponent";

import {Row, Col, Card, ListGroup} from 'react-bootstrap';

import DokumentacjaNauczycielaIcon from '../assets/img/dokumentacja-nauczyciela.png';
import DiagnozaIcon from '../assets/img/diagnoza.png';
import DlaUkrainy from '../assets/img/dla-ukrainy.png';
import JezykiObceIcon from '../assets/img/jezyki-obce.png';
import KartyPracyIcon from '../assets/img/karty-pracy.png';
import MaterialyDodatkoweIcon from '../assets/img/materialy-dodatkowe.png';
import NagraniaIcon from '../assets/img/nagrania.png';
import PlanszeIcon from '../assets/img/plansze.png';
import ScenariuszeIcon from '../assets/img/scenariusze.png';


const PreSchoolEduCategoriesPartial = ({language = "wychowanie-przedszkolne", renderType = "cards", activeCat = null}) => {

  const { isLoading, data, isError, isFetching } = useQuery(
    {
        queryKey: ['categoriesList', language],
        queryFn: () => getCategoriesByLanguage(language == "wychowanie-przedszkolne" ? "wychowanie-przedszkolne" : "jezyki"),
        enabled: true,
        staleTime: Infinity,
        retry: false
    }
  )

  if(isLoading || isFetching){
    return <LoadingComponent />
  }

  if(isError){
      return <div>Wystapił bład podczas ładowania treści</div>
  }

  const icon = (slug) => {
    switch (slug) {
      case "dokumentacja-nauczyciela" : return DokumentacjaNauczycielaIcon; break;
      case "diagnoza" : return DiagnozaIcon; break;
      case "dla-ukrainy" : return DlaUkrainy; break;
      case "jezyki-obce" : return JezykiObceIcon; break;
      case "karty-pracy" : return KartyPracyIcon; break;
      case "materialy-dodatkowe" : return MaterialyDodatkoweIcon; break;
      case "nagrania" : return NagraniaIcon; break;
      case "plansze" : return PlanszeIcon; break;
      case "scenariusze" : return ScenariuszeIcon; break;
      case "materialy-na-lekcje" : return ScenariuszeIcon; break;
      case "sprawdziany-kartkowki-testy" : return DiagnozaIcon; break;
      case "dodatkowe-materialy" : return MaterialyDodatkoweIcon; break;
      case "dokumentacja-szkolna" : return DokumentacjaNauczycielaIcon; break;
      case "materialy-dla-uczniow-z-dysleksja" : return KartyPracyIcon; break;
      case "materialy-do-kopiowania" : return PlanszeIcon; break;
      case "testy-kartkowki-diagnoza" : return DiagnozaIcon; break;
      case "scenariusze-lekcji" : return ScenariuszeIcon; break;
      default: return DokumentacjaNauczycielaIcon; break;
    }
  }

  const renderAsCards = () => {
    return(
      <Row className="py-3">
        {
          data?.data.data.map((item, key) => {
            return(
              <Col sm={12} md={3} lg={3} className="py-3" key={key}>
                <Card>
                <Card.Img variant="top" className="mt-4" src={icon(item.slug)} />
                  <Card.Body>
                    <Card.Title className="mb-2 text-muted"><strong>{getCategoryFullName(item.slug)}</strong></Card.Title>
                    <a href={'/' + language + '/' + item.slug} className="w-100 mt-2 btn btn-outline-primary">Dalej</a>
                  </Card.Body>
                </Card>
              </Col>
            );
          })
        }
      </Row>
    );
  }

  const renderAsList = () => {
    return(
      <Card className="p-0">
        <Card.Header  className="bg-violet text-white"><strong>Kategorie</strong></Card.Header>
        <ListGroup className="list-group-flush"> 
          {
            data?.data.data.map((item, key) => {
              let active = item.slug === activeCat ? true : false;
              return(
                <ListGroup.Item active={active} key={key}><a href={'/' + language + '/' + item.slug}><strong>{getCategoryFullName(item.slug)}</strong></a></ListGroup.Item>
              );
            })
          }
        </ListGroup>
      </Card>
    );
  }

  let view = renderType === "cards" ? renderAsCards() : renderAsList();
  return(
    <React.Fragment>
      {view}
    </React.Fragment>
  )

}
export default PreSchoolEduCategoriesPartial;